import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { SettingsService, SettingsStorage } from '@next/core-lib/settings';
import { Observable, Subject } from 'rxjs';
import { debounceTime, map, takeUntil } from 'rxjs/operators';

import { SettingsKeys, settingsContextName } from '../shared/models/shared.models';
import { GbmOverviewComponent } from './components/gbm-overview/gbm-overview.component';
import { GbmTotalsComponent } from './components/gbm-totals/gbm-totals.component';

@Component({
  selector: 'app-gbm',
  templateUrl: './gbm.component.html',
  imports: [GbmOverviewComponent, GbmTotalsComponent, AsyncPipe],
})
export class GbmComponent implements OnInit, OnDestroy {
  public showTotals$: Observable<boolean>;
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly settingsService: SettingsService) {}

  ngOnInit(): void {
    this.showTotals$ = this.settingsService
      .getSettingsUpdates({
        contextName: settingsContextName,
        storage: SettingsStorage.PlatformSession,
        key: SettingsKeys.totals,
      })
      .pipe(
        debounceTime(0),
        map((settings) =>
          settings?.map((setting) => (Array.isArray(setting) ? setting[0] : setting)),
        ),
        map((settings) => settings?.[0]?.data as boolean),
        takeUntil(this.destroy$),
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
